import { render } from "./CategorySaleForm.vue?vue&type=template&id=1fdeaf24&scoped=true&ts=true"
import script from "./CategorySaleForm.vue?vue&type=script&lang=ts"
export * from "./CategorySaleForm.vue?vue&type=script&lang=ts"

import "./CategorySaleForm.vue?vue&type=style&index=0&id=1fdeaf24&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdeaf24"]])

export default __exports__